import {Input} from 'antd';
import React from "react";

class MoneyInput extends React.Component {
    onChange = (e) => {
        const {value} = e.target;
        const reg = /^([1-9]\d{0,4}|0)([.]?|(\.\d{1,2})?)$/;

        /* if ((!isNaN(value) && reg.test(value)) || value === '') {
             this.props.onChange(value);
         }*/

        if ((reg.test(value)) || value === '') {
            this.props.onChange(value);
        }
    }
    // '.' at the end or only '-' in the input box.
    onBlur = () => {
        const {value, onBlur, onChange} = this.props;
        if (onBlur) {
            onBlur();
        }
    }

    render() {
        return (
            <Input
                {...this.props}
                onChange={this.onChange}
                onBlur={this.onBlur}
            />
        );
    }
}

export default MoneyInput;


// WEBPACK FOOTER //
// ./src/components/MoneyInput.jsx